import React from 'react'
import { Link } from 'react-router-dom'

export default function GoaDining() {
  return (
    <>
    <section className="goa-dinning">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-8 col-md-9">
                    <div className="goa-shapeheading">
                        <h4 className='heading'>Indulge Every Sense</h4>
                        <img src="/image/bigimage-shape.webp" alt="shape" loading="lazy"/>
                        <p>Every meal is a memory in the making at Ice & Spice, our signature multi-cuisine restaurant. From the sizzling aromas of our live grills to the authentic zest of Goan staples and soul-warming global favorites, we serve flavors that speak to the heart. Whether it's a slow breakfast or a romantic dinner under the stars, every bite is a celebration of the good life.</p>
                    </div>
                </div>
            </div>

            <div className="row justify-content-between align-items-center">
                <div className="col-lg-6 col-md-6 col-sm-6">
                    <Link to="/resort-de-coracao-goa/cuisine" className="goadinning-box">
                        <picture>
                            <img src="/image/goa-dinning-1.webp" className="img-responsive" alt="dinning" loading="lazy"/>
                        </picture>
                        <div>
                            <p>Splash & Savour</p>
                            <img src="/image/mediumright-arrow.svg" alt="arrow" loading="lazy"/>
                        </div>
                    </Link>

                    <Link to="/resort-de-coracao-goa/cuisine" className="goadinning-box second-goadinning wow animate__animated animate__slideInLeft" data-wow-delay="0.1s" data-wow-duration="1.1s">
                        <picture>
                            <img src="/image/goa-dinning-2.webp" className="img-responsive" alt="dinning" loading="lazy"/>
                        </picture>
                        <div>
                            <p>Spice & Salt</p>
                            <img src="/image/mediumright-arrow.svg" alt="arrow" loading="lazy"/>
                        </div>
                    </Link>
                </div>

                <div className="col-lg-5 col-md-5 col-sm-5">
                    <Link to="/resort-de-coracao-goa/cuisine" className="goadinning-box wow animate__animated animate__slideInRight" data-wow-delay="0.1s" data-wow-duration="1.2s">
                        <picture>
                            <img src="/image/goa-dinning-3.webp" className="img-responsive" alt="dinning" loading="lazy"/>
                        </picture>
                        <div>
                            <p>Grill Ember Table</p>
                            <img src="/image/mediumright-arrow.svg" alt="arrow" loading="lazy"/>
                        </div>
                    </Link>
                </div>
            </div>

        </div>
    </section>  
    </>
  )
}
